import { useSettings } from '@wix/tpa-settings/react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import settingsParams from '../settingsParams';
import { SectionTypes } from '../types';
import { VisibilityKey } from './types';

export function useAddVisibilityClass() {
  const { isCssPerBreakpoint } = useEnvironment();
  const settings = useSettings();

  return {
    isCssPerBreakpoint,
    addVisibilityClass: (
      className: string,
      visibilityClassName: string,
      key?: VisibilityKey,
    ) => {
      return isCssPerBreakpoint &&
        (!key || typeof settings.get(settingsParams[key]) !== 'boolean')
        ? className
          ? `${className} ${visibilityClassName}`
          : visibilityClassName
        : className;
    },
    addSectionBookButtonVisibilityClass: (
      className: string,
      visibilityClassName: string,
      sectionType: SectionTypes,
    ) => {
      const section = settings
        .get(settingsParams.sections)
        .find((currSection) => currSection.type === sectionType);
      return isCssPerBreakpoint
        ? className
          ? `${className} ${visibilityClassName}`
          : visibilityClassName
        : className;
    },
    addSectionVisibilityClass: (
      className: string,
      visibilityClassName: string,
      sectionType: SectionTypes,
    ) => {
      const section = settings
        .get(settingsParams.sections)
        .find((currSection) => currSection.type === sectionType);
      return isCssPerBreakpoint
        ? className
          ? `${className} ${visibilityClassName}`
          : visibilityClassName
        : className;
    },
  };
}
